import { render, staticRenderFns } from "./MakeCustomTaskComponent.vue?vue&type=template&id=4155b690&scoped=true"
import script from "./MakeCustomTaskComponent.vue?vue&type=script&lang=js"
export * from "./MakeCustomTaskComponent.vue?vue&type=script&lang=js"
import style0 from "./MakeCustomTaskComponent.vue?vue&type=style&index=0&id=4155b690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155b690",
  null
  
)

export default component.exports